// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import EnrollFormModal from "../pages/EnrollFormModal";
import "../styles/CoursesPage.css";

// const DataScienceCourses = [
//   {
//     name: "Python",
//     description: "Learn Python from basics to advanced with hands-on examples.",
//     image: "/images/Python.png",
//     link: "/courses/details/Python",
//   },
//   {
//     name: "SQL",
//     description: "Master SQL queries, database management, and optimization techniques.",
//     image: "/images/SQL.png",
//     link: "/courses/details/SQL",
//   },
//   {
//     name: "Basic Statistics & Data Mining",
//     description: "Understand statistical concepts and data mining techniques.",
//     image: "/images/Statistics.png",
//     link: "/courses/details/Basic%20Statistics%20%26%20Data%20Mining",
//   },
//   {
//     name: "Machine Learning",
//     description: "Dive into ML algorithms, model building, and real-world applications.",
//     image: "/images/M.png",
//     link: "/courses/details/MachineLearning",
//   },
//   {
//     name: "Deep Learning",
//     description: "Explore neural networks, CNNs, RNNs, and deep learning frameworks.",
//     image: "/images/deeplearning.png",
//     link: "/courses/details/deeplearning",
//   },
// ];

// const DataAnalyticsCourses = [
//   {
//     name: "Foundations of Data Analytics + Excel ",
//     description: "Hands-on Python training tailored for data-driven tasks.",
//     image: "/images/FoundationsDA.png",
//     link: "/courses/details/DataAnalyticsExcel",
//   },
//   {
//     name: "Python for Data Analytics",
//     description: "Hands-on Python training tailored for data-driven tasks.",
//     image: "/images/Python.png",
//     link: "/courses/details/PythonForDataAnalytics",
//   },
//   {
//     name: "SQL for Data Handling",
//     description: "SQL essentials and advanced techniques for data analysis.",
//     image: "/images/SQL.png",
//     link: "/courses/details/SQLForDataHandling",
//   },
//   {
//     name: "Statistics & Data Cleaning",
//     description: "Master data cleaning techniques and statistical foundations.",
//     image: "/images/Statistics.png",
//     link: "/courses/details/StatisticsAndDataCleaning",
//   },
//   {
//     name: "Tableau for Data Visualization",
//     description: "Build powerful dashboards and data stories with Tableau.",
//     image: "/images/Tableau.png",
//     link: "/courses/details/TableauForDataViz",
//   },
//   {
//     name: "Power BI for Business Reporting",
//     description: "Create impactful business reports with Power BI.",
//     image: "/images/PowerBi.png",
//     link: "/courses/details/PowerBIForBusiness",
//   },
 
//   {
//     name: "Capstone Project",
//     description: "End-to-End Project.",
//     image: "/images/CapstonePJ.png",
//     link: "/courses/details/CapstoneProject",
//   },
// ];

// const CoursesPage = () => {
//   const [courses, setCourses] = useState([]);
//   const [showEnrollForm, setShowEnrollForm] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Retrieve 'program' query parameter from URL
//   const queryParams = new URLSearchParams(location.search);
//   const program = queryParams.get("program");

//   useEffect(() => {
//     // Set courses based on 'program' parameter
//     if (program === "datalns") {
//       setCourses(DataAnalyticsCourses);
//     } else {
//       setCourses(DataScienceCourses);
//     }
//   }, [program]);

//   const handleBackButtonClick = () => {
//     // Check if program is set in URL params and navigate accordingly
//     if (program === "datalns") {
//       navigate("/coursesoffered?program=datalns"); // Data Analytics
//     } else {
//       navigate("/coursesoffered?program=datasci"); // Data Science
//     }
//   };

//   return (
//     <div className="courses-container">
//       <div className="courses-header">
//         <h2 className="courses-title">
//           {program === "datalns" ? "Data Analytics" : "Data Science"}
//         </h2>

//         {/* Enroll Button */}
//         <div className="enroll-button-wrapper">
//           <button className="enroll-top-button" onClick={() => setShowEnrollForm(true)}>
//             Enroll Now
//           </button>
//           <EnrollFormModal
//             isOpen={showEnrollForm}
//             onClose={() => setShowEnrollForm(false)}
//           />
//         </div>

//         {/* Back Button
//         <button
//           onClick={handleBackButtonClick}
//           className="back-button"
//         >
//           Back
//         </button> */}

//         {/* Mobile Back (optional) */}
//         <div className="mobile-button-group">
//           <button
//             onClick={handleBackButtonClick}
//             className="back-button"
//           >
//             Back
//           </button>
//         </div>
//       </div>

//       {/* Courses Grid */}
//       <div className="courses-grid">
//         {courses.length === 0 ? (
//           <p>Please wait, courses are loading...</p>
//         ) : (
//           courses.map((course, index) => (
//             <div className="course-card" key={index}>
//               <img
//                 className="course-image"
//                 src={course.image}
//                 alt={course.name}
//               />
//               <h3 className="course-name">
//                 {/* Course link with program parameter */}
//                 <Link to={`${course.link}?program=${program || "datasci"}`}>
//                   {course.name}
//                 </Link>
//               </h3>
//               <p className="course-description">{course.description}</p>
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default CoursesPage;
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import EnrollFormModal from "./EnrollFormModal";
// import "../styles/CoursesPage.css";
// import { fetchCourses } from "../API/API"; // ✅ Ensure this function exists and is exported

// // Dummy data for fallback
// const DataScienceCourses = [
//   {
//     name: "Python",
//     description: "Learn Python from basics to advanced with hands-on examples.",
//     image: "/images/Python.png",
//     link: "/courses/details/Python",
//   },
//   {
//     name: "SQL",
//     description: "Master SQL queries, database management, and optimization techniques.",
//     image: "/images/SQL.png",
//     link: "/courses/details/SQL",
//   },
//   {
//     name: "Basic Statistics & Data Mining",
//     description: "Understand statistical concepts and data mining techniques.",
//     image: "/images/Statistics.png",
//     link: "/courses/details/Basic%20Statistics%20%26%20Data%20Mining",
//   },
//   {
//     name: "Machine Learning",
//     description: "Dive into ML algorithms, model building, and real-world applications.",
//     image: "/images/M.png",
//     link: "/courses/details/MachineLearning",
//   },
//   {
//     name: "Deep Learning",
//     description: "Explore neural networks, CNNs, RNNs, and deep learning frameworks.",
//     image: "/images/deeplearning.png",
//     link: "/courses/details/deeplearning",
//   },
// ];

// const DataAnalyticsCourses = [
//   {
//     name: "Foundations of Data Analytics + Excel ",
//     description: "Hands-on Python training tailored for data-driven tasks.",
//     image: "/images/FoundationsDA.png",
//     link: "/courses/details/DataAnalyticsExcel",
//   },
//   {
//     name: "Python for Data Analytics",
//     description: "Hands-on Python training tailored for data-driven tasks.",
//     image: "/images/Python.png",
//     link: "/courses/details/PythonForDataAnalytics",
//   },
//   {
//     name: "SQL for Data Handling",
//     description: "SQL essentials and advanced techniques for data analysis.",
//     image: "/images/SQL.png",
//     link: "/courses/details/SQLForDataHandling",
//   },
//   {
//     name: "Statistics & Data Cleaning",
//     description: "Master data cleaning techniques and statistical foundations.",
//     image: "/images/Statistics.png",
//     link: "/courses/details/StatisticsAndDataCleaning",
//   },
//   {
//     name: "Tableau for Data Visualization",
//     description: "Build powerful dashboards and data stories with Tableau.",
//     image: "/images/Tableau.png",
//     link: "/courses/details/TableauForDataViz",
//   },
//   {
//     name: "Power BI for Business Reporting",
//     description: "Create impactful business reports with Power BI.",
//     image: "/images/PowerBi.png",
//     link: "/courses/details/PowerBIForBusiness",
//   },
//   {
//     name: "Capstone Project",
//     description: "End-to-End Project.",
//     image: "/images/CapstonePJ.png",
//     link: "/courses/details/CapstoneProject",
//   },
// ];
// const DataEngineering = [
//   {
//     name: "Python Programming for Data Engineering",
//     description: "Hands-on Python training tailored for data-driven tasks.",
//     image: "/images/Python.png",
//     link: "/courses/details/DataAnalyticsExcel",
//   },
//   {
//     name: "Exploratory Data Analysis (EDA)",
//     description: "Hands-on Python training tailored for data-driven tasks.",
//     image: "/images/Python.png",
//     link: "/courses/details/PythonForDataAnalytics",
//   },
//   {
//     name: "SQL for Data Engineering",
//     description: "SQL essentials and advanced techniques for data analysis.",
//     image: "/images/SQL.png",
//     link: "/courses/details/SQLForDataHandling",
//   },
//   {
//     name: "Introduction to Data Engineering",
//     description: "Master data cleaning techniques and statistical foundations.",
//     image: "/images/Statistics.png",
//     link: "/courses/details/StatisticsAndDataCleaning",
//   },
//   {
//     name: "Data Sources and NoSQL Databases",
//     description: "Build powerful dashboards and data stories with Tableau.",
//     image: "/images/Tableau.png",
//     link: "/courses/details/TableauForDataViz",
//   },
//   {
//     name: "Power BI for Business Reporting",
//     description: "Create impactful business reports with Power BI.",
//     image: "/images/PowerBi.png",
//     link: "/courses/details/PowerBIForBusiness",
//   },
//   {
//     name: "Capstone Project",
//     description: "End-to-End Project.",
//     image: "/images/CapstonePJ.png",
//     link: "/courses/details/CapstoneProject",
//   },
// ];

// const CoursesPage = () => {
//   const [courses, setCourses] = useState([]);
//   const [showEnrollForm, setShowEnrollForm] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Get 'program' from query string
//   const queryParams = new URLSearchParams(location.search);
//   const program = queryParams.get("program");

//   useEffect(() => {
//     const loadCourses = async () => {
//       try {
//         const response = await fetchCourses(); // 🔗 Your API call
//         const allCourses = response.data || response; // in case API returns raw array

//         // Filter by program if the field exists
//         const filteredCourses = allCourses.filter((course) => {
//           return course.program?.toLowerCase() === program?.toLowerCase();
//         });

//         if (filteredCourses.length > 0) {
//           setCourses(filteredCourses);
//         } else {
//           // Fallback based on known program values
//           if (program === "datalns") {
//             setCourses(DataAnalyticsCourses);
//           } else {
//             setCourses(DataScienceCourses);
//           }
//         }
//       } catch (error) {
//         console.error("API failed, using fallback data:", error);
//         if (program === "datalns") {
//           setCourses(DataAnalyticsCourses);
//         } else {
//           setCourses(DataScienceCourses);
//         }
//       }
//     };

//     loadCourses();
//   }, [program]);

//   const handleBackButtonClick = () => {
//     if (program === "datalns") {
//       navigate("/coursesoffered?program=datalns");
//     } else {
//       navigate("/coursesoffered?program=datasci");
//     }
//   };

//   return (
//     <div className="courses-container">
//       <div className="courses-header">
//         <h2 className="courses-title">
//           {program === "datalns" ? "Data Analytics" : "Data Science"}
//         </h2>

//         <div className="enroll-button-wrapper">
//           <button className="enroll-top-button" onClick={() => setShowEnrollForm(true)}>
//             Enroll Now
//           </button>
//           <EnrollFormModal
//             isOpen={showEnrollForm}
//             onClose={() => setShowEnrollForm(false)}
//           />
//         </div>

//         <div className="mobile-button-group">
//           <button onClick={handleBackButtonClick} className="back-button">
//             Back
//           </button>
//         </div>
//       </div>

//       <div className="courses-grid">
//         {courses.length === 0 ? (
//           <p>Please wait, courses are loading...</p>
//         ) : (
//           courses.map((course, index) => (
//             <div className="course-card" key={index}>
//               <img className="course-image" src={course.image} alt={course.name} />
//               <h3 className="course-name">
//                 <Link to={`${course.link}?program=${program || "datasci"}`}>
//                   {course.name}
//                 </Link>
//               </h3>
//               <p className="course-description">{course.description}</p>
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// };
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchCourses } from "../API/API";
// import EnrollFormModal from "../pages/EnrollFormModal";

const dummyCourses = {
  "Data Science": [
    {
      name: "Python",
      description: "Learn Python from basics to advanced with hands-on examples.",
      image: "/images/Python.png",
      link: "/courses/details/Python",
    },
    {
      name: "SQL",
      description: "Master SQL queries, database management, and optimization techniques.",
      image: "/images/SQL.png",
      link: "/courses/details/SQL",
    },
    {
      name: "Basic Statistics & Data Mining",
      description: "Understand statistical concepts and data mining techniques.",
      image: "/images/Statistics.png",
      link: "/courses/details/Basic%20Statistics%20%26%20Data%20Mining",
    },
    {
      name: "Machine Learning",
      description: "Dive into ML algorithms, model building, and real-world applications.",
      image: "/images/M.png",
      link: "/courses/details/MachineLearning",
    },
    {
      name: "Deep Learning",
      description: "Explore neural networks, CNNs, RNNs, and deep learning frameworks.",
      image: "/images/deeplearning.png",
      link: "/courses/details/deeplearning",
    },
  ],
  "Data Analytics": [
    {
      name: "Foundations of Data Analytics + Excel ",
      description: "Hands-on Python training tailored for data-driven tasks.",
      image: "/images/FoundationsDA.png",
      link: "/courses/details/DataAnalyticsExcel",
    },
    {
      name: "Python for Data Analytics",
      description: "Hands-on Python training tailored for data-driven tasks.",
      image: "/images/Python.png",
      link: "/courses/details/PythonForDataAnalytics",
    },
    {
      name: "SQL for Data Handling",
      description: "SQL essentials and advanced techniques for data analysis.",
      image: "/images/SQL.png",
      link: "/courses/details/SQLForDataHandling",
    },
    {
      name: "Statistics & Data Cleaning",
      description: "Master data cleaning techniques and statistical foundations.",
      image: "/images/Statistics.png",
      link: "/courses/details/StatisticsAndDataCleaning",
    },
    {
      name: "Tableau for Data Visualization",
      description: "Build powerful dashboards and data stories with Tableau.",
      image: "/images/Tableau.png",
      link: "/courses/details/TableauForDataViz",
    },
    {
      name: "Power BI for Business Reporting",
      description: "Create impactful business reports with Power BI.",
      image: "/images/PowerBi.png",
      link: "/courses/details/PowerBIForBusiness",
    },
    {
      name: "Capstone Project",
      description: "End-to-End Project.",
      image: "/images/CapstonePJ.png",
      link: "/courses/details/CapstoneProject",
    },
  ],
   "Generative AI and Prompt Engineering": [
    {
      name: "Introduction to AI and Generative AI",
      description: "",
      image: "/images/AIvsGenAI.png",
      link: "/courses/details/IntroductiontoAIandGenerativeAI",
    },
    {
      name: "Neural Networks Basics",
      description: "",
      image: "/images/NN-ANNvsCNNvsRNN.png",
      link: "/courses/details/NeuralNetworksBasics",
    },
    {
      name: "Sequence Models",
      description: "",
      image: "/images/SequenceModels.png",
      link: "/courses/details/SequenceModels",
    },
    {
      name: "Introduction to NLP",
      description: "",
      image: "/images/TextMining-NLP.png",
      link: "/courses/details/IntroductiontoNLP",
    },
    {
      name: "The Transformer Revolution",
      description: "",
      image: "/images/TransformerArchecture.png",
      link: "/courses/details/TheTransformerRevolution",
    },
       {
      name: "Language Models",
      description: "",
      image: "/images/BERTvsGPT.png",
      link: "/courses/details/LanguageModels",
    },
    {
      name: "Generative Models",
      description: "",
      image: "/images/GenAIModels.png",
      link: "/courses/details/GenerativeModels",
    },
    {
      name: "Introduction to LLMs",
      description: "",
      image: "/images/LLMModels.png",
      link: "/courses/details/IntroductiontoLLMs",
    },
    {
      name: "Customization and Optimization",
      description: "",
      image: "/images/Hyperparameters.png",
      link: "/courses/details/CustomizationandOptimization",
    },
    {
      name: "Real-World Challenges with LLMs",
      description: "",
      image: "/images/ChallengesofLLMs.png",
      link: "/courses/details/Real-WorldChallengeswithLLMs",
    },
    {
      name: "Prompt Engineering",
      description: "",
      image: "/images/PromptEngg.png",
      link: "/courses/details/PromptEngineering",
    },
    {
      name: "Retrieval-Augmented Generation (RAG)",
      description: "",
      image: "/images/RAG.png",
      link: "/courses/details/Retrieval-AugmentedGeneration(RAG)",
    },
    {
      name: "Frameworks and LLM Applications",
      description: "",
      image: "/images/FrameworksandLLMApps.png",
      link: "/courses/details/FrameworksandLLMApplications",
    },
    {
      name: "Building AI Agents",
      description: "",
      image: "/images/AIAgents.png",
      link: "/courses/details/BuildingAIAgents",
    },
    {
      name: "GenAI Capston Project",
      description: "Build powerful dashboards and data stories with Tableau.",
      image: "/images/GenAI-Capston.png",
      link: "/courses/details/GenAICapstonProject",
    },
 
 
  ],

  "Data Engineering": [
    {
      name: "Python Programming for Data Engineering",
      description: "Hands-on Python training tailored for data-driven tasks.",
      image: "/images/Python.png",
      link: "/courses/details/PythonProgrammingforDataEngineering",
    },
    {
      name: "Exploratory Data Analysis (EDA)",
      description: "",
      image: "/images/EDA.png",
      link: "/courses/details/ExploratoryDataAnalysis(EDA)",
    },
    {
      name: "SQL for Data Engineering",
      description: "SQL essentials and advanced techniques for data analysis.",
      image: "/images/SQL.png",
      link: "/courses/details/SQLforDataEngineering",
    },
    {
      name: "Introduction to Data Engineering",
      description: "", 
      image: "/images/IntrotoDE.png",
      link: "/courses/details/IntroductiontoDataEngineering",
    },
    {
      name: "Data Sources and NoSQL Databases",
      description: "",
      image: "/images/NoSQL.png",
      link: "/courses/details/DataSourcesandNoSQLDatabases",
    },
    {
      name: "Big Data Concepts and Hadoop Ecosystem",
      description: "",
      image: "/images/BigData.png",
      link: "/courses/details/BigDataConceptsandHadoopEcosystem",
    },
    {
      name: "Apache Kafka for Streaming Pipelines",
      description: "",
      image: "/images/Apachekafka.png",
      link: "/courses/details/ApacheKafkaforStreamingPipelines",
    },
    {
      name: "Apache Airflow for Workflow Orchestration",
      description: "",
      image: "/images/ApacheAirflow.png",
      link: "/courses/details/ApacheAirflowforWorkflowOrchestration",
    },
    {
      name: "Introduction to Cloud Platforms",
      description: "",
      image: "/images/IntrotoCloudPlatforms.png",
      link: "/courses/details/IntroductiontoCloudPlatforms",
    },
    {
      name: "Data Engineering with AWS",
      description: "",
      image: "/images/DEwithAWS.png",
      link: "/courses/details/DataEngineeringwithAWS",
    },
    {
      name: "Data Engineering with Azure",
      description: "",
      image: "/images/DEwithAzure.png",
      link: "/courses/details/DataEngineeringwithAzure",
    },
    {
      name: "Data Engineering with GCP",
      description: "",
      image: "/images/DEwithGCP.png",
      link: "/courses/details/DataEngineeringwithGCP",
    },
    {
      name: "Final Capstone Project (Optional)",
      description: "End-to-End Project.",
      image: "/images/DE-Project.jpg",
      link: "/courses/details/FinalCapstoneProject(Optional)",
    },
  ],
  "MLOps: Machine Learning Operations": [
    {
      name: "Python Fundamentals",
      description: "",
      image: "/images/Python Fundamentals",
      link: "/courses/details/PythonFundamentals",
    },           
    {
      name: "SQL Programming",
      description: "",
      image: "/images/",
      link: "/courses/details/SQL-Programming",
    },
    {
      name: "Introduction to MLOps",
      description: "",
      image: "/images/Introduction to MLOps.png",
      link: "/courses/details/IntroductiontoMLOps",
    },
    {
      name: "Versioning: Code, Data, and Models",
      description: "", 
      image: "/images/Versioning: Code, Data, and Models.png",
      link: "/courses/details/Versioning:Code,Data,andModels",
    },
    {
      name: "Containerizing",
      description: "",
      image: "/images/Containerizing.png",
      link: "/courses/details/Containerizing",
    },
    {
      name: "Experiment Tracking",
      description: "",
      image: "/images/Experiment-Tracking.png",
      link: "/courses/details/ExperimentTracking",
    },
    {
      name: "Model Deployment",
      description: "",
      image: "/images/Model Deployment.png",
      link: "/courses/details/ModelDeployment",
    },
    {
      name: "CI/CD for ML",
      description: "",
      image: "/images/CI/CD for ML.png",
      link: "/courses/details/CI/CDforML",
    },
    
    {
      name: "Monitoring ML Models",
      description: "",
      image: "/images/Monitoring-ML-Models.png",
      link: "/courses/details/MonitoringMLModels",
    },
    {
      name: "Orchestration and Pipelines",
      description: "",
      image: "/images/Orchestration-and-Pipelines.png",
      link: "/courses/details/OrchestrationandPipelines",
    },
    {
      name: "End-to-End MLOps Project",
      description: "Design and implement a complete ML system — from data ingestion to deployment with monitoring — using real datasets and engineering best practices.",
      image: "/images/MLEngg_capstone.png",
      link: "/courses/details/FinalCapstoneProject(Optional)",
    },
  ],
  "OCI Infrastructure Architect Associate": [
    {
      name: "Cloud Concepts & OCI Fundamentals",
      description: "",
      image: "/images/",
      link: "/courses/details/CloudConcepts&OCIFundamentals",
    },
    {
      name: " Identity & Access Management (IAM) - Advanced",
      description: "",
      image: "/images/",
      link: "/courses/details/Identity&AccessManagement(IAM)-Advanced",
    },
    {
      name: " Compute & Edge Services",
      description: "",
      image: "/images/",
      link: "/courses/details/Compute&EdgeServices",
    },
    {
      name: "Storage & Data Transfer",
      description: "", 
      image: "/images/",
      link: "/courses/details/Storage & Data Transfer",
    },
    {
      name: "Advanced Networking & Security",
      description: "",
      image: "/images/",
      link: "/courses/details/AdvancedNetworking&Security",
    },
    {
      name: "Databases in OCI (2025 Updates)",
      description: "",
      image: "/images/",
      link: "/courses/details/DatabasesinOCI(2025 Updates)",
    },
    {
      name: "Security, Observability & Governance",
      description: "",
      image: "/images/",
      link: "/courses/details/Security,Observability&Governance",
    },
    {
      name: "Migration & Modernization",
      description: "",
      image: "/images/",
      link: "/courses/details/Migration&Modernization",
    },
    {
      name: " Certification Prep & Mock Exams",
      description: "",
      image: "/images/",
      link: "/courses/details/CertificationPrep&MockExams",
    },
  ],
   "Machine Learning Engineering": [
    {
      name: "Foundations of ML Engineering",
      description: "",
      image: "/images/FMLEngg.png",
      link: "/courses/details/FoundationsofMLEngineering",
    },
    {
      name: "Python for ML Engineering",
      description: "",
      image: "/images/PythonforMLEngg.png",
      link: "/courses/details/PythonforMLEngineering",
    },
    {
      name: "Unsupervised & Supervised Learning",
      description: "",
      image: "/images/U&SL.png",
      link: "/courses/details/Unsupervised&SupervisedLearning",
    },
    {
      name: "Feature Engineering",
      description: "", 
      image: "/images/FeatureEngineering.png",
      link: "/courses/details/FeatureEngineering",
    },
    {
      name: "ML Experimentation & Versioning",
      description: "",
      image: "/images/MLE&V.png",
      link: "/courses/details/MLExperimentation&Versioning",
    },
    {
      name: "Deployment & APIs",
      description: "",
      image: "/images/Deployment&APIs.png",
      link: "/courses/details/Deployment&APIs",
    },
    {
      name: "Data Engineering for ML Pipelines",
      description: "",
      image: "/images/DataEngineeringforMLPipelines.png",
      link: "/courses/details/DataEngineeringforMLPipelines",
    },
    {
      name: "Workflow Orchestration & CI/CD",
      description: "",
      image: "/images/WO&CICD.png",
      link: "/courses/details/WorkflowOrchestration&CI-CD",
    },
    {
      name: "Monitoring & MLOps",
      description: "",
      image: "/images/M&MLOps.png",
      link: "/courses/details/Monitoring&MLOps",
    },
    {
      name: "ML Capstone Project",
      description: "",
      image: "/images/MLEnggCP.png",
      link: "/courses/details/MLCapstoneProject",
    },
  ],
};

const CoursesPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  //  const [showEnrollForm, setShowEnrollForm] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const program = searchParams.get("program");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCourses = async () => {
      try {
        const response = await fetchCourses();
        const fetched = response?.data || [];
        const programCourses = fetched.filter(
          (course) => course.program?.toLowerCase() === program?.toLowerCase()
        );
        if (programCourses.length > 0) {
          setCourses(programCourses);
        } else {
          setCourses(dummyCourses[program] || []);
        }
      } catch (error) {
        console.error("API failed, using fallback data:", error);
        setCourses(dummyCourses[program] || []);
      } finally {
        setLoading(false);
      }
    };

    loadCourses();
  }, [program]);

  if (loading) return <div>Loading courses...</div>;

  return (
    <div className="courses-container">
      <div className="courses-header">
        <div className="back-button-wrapper">
        <button className="back-button" onClick={() => navigate(-1)}>
          &larr; Back
        </button>
        </div>
        {/* <div className="top-enroll-container">
        <button className="top-enroll-btn" onClick={() => setShowEnrollForm(true)}>
          Enroll
        </button>
      </div>
      <EnrollFormModal isOpen={showEnrollForm} onClose={() => setShowEnrollForm(false)} /> */}
        {/* If you want an enroll button on top, uncomment below */}
        {/* <div className="enroll-button-wrapper">
          <button className="enroll-top-button">Enroll Now</button>
        </div> */}
        <h1 className="courses-title">{program} Modules</h1>
      </div>
      <div className="courses-grid">
        {courses.map((course, index) => (
          <div key={index} className="course-card">
            <img className = "course-image1"
              src={course.image}
              alt={course.name}
            />
            <div className="course-name">
              <a href={course.link}>{course.name}</a>
            </div>
            <p className="course-description">{course.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoursesPage;
